import React, { useState, useCallback, useEffect } from "react";
import api from "Helpers/Api";
import { useHistory, useParams } from "react-router-dom";
import Routes from "Routes";
import * as Styledd from "../../../Components/Filters2/styles";
import * as Styled from "./styles";
import List from "Components/List";
import { IPagination } from "Services/pagination";
import { TRange } from "Services/pagination";
import PageTitle from "Components/Base/PageTitle";
import Cities, { ICity } from "Components/Form/Inputs/Cities";
import States, { IState } from "Components/Form/Inputs/States";
import AdItem from "Components/AdItem";
import CheckboxSearch, {
  IOptions,
} from "Components/Form/Inputs/CheckboxSearch";
import { TSubcategory } from "Services/Category";
import { TError } from "Services/Error/error";
import { IAd } from "Services/Ad/ad";
import stringRange from "Helpers/stringRange";
import {
  PRODUCT_VEHICLE_CATEGORY_ID,
  TECHNICAL_ATTRIBUTES,
} from "Helpers/consts";

import FilterItems from "Components/Filters/FilterItems";
import RangeField from "Components/Form/Inputs/RangeField";
import Sorting, { TSortingValue } from "Components/Sorting";
import { Categories } from "Components/Filters/Categories";
import HeaderPageTitle from "Components/Base/HeaderPageTitle";
import Loading from "Components/Loading";
import List2 from "Components/List2";
import { useVehicles } from "Hooks/Vehicles/useVehicles";
import { useSelector } from "react-redux";
import { ReducerState } from "Redux/store";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

interface Props {
  row?: number;
  perPage?: number;
  hideSearch?: boolean;
  hidePagination?: boolean;
  hideFilters?: boolean;
  hideSorting?: boolean;
  inline?: boolean;
  userId?: number;
  published?: boolean;
  title?: string;
  link?: string;
  setNoResults?: React.Dispatch<React.SetStateAction<boolean>>;
}

type TParams = {
  category: string;
  subcategory: string;
};

const VehicleList: React.FC<Props> = ({
  row = 3,
  perPage = 12,
  hideSearch = false,
  hideFilters = false,
  hidePagination = false,
  hideSorting = false,
  inline = false,
  userId,
  published = true,
  title,
  link = "",
  setNoResults,
}) => {
  const history = useHistory();

  const { category: c = "", subcategory: s = "" } = useParams<TParams>();

  const [sorting, setSorting] = useState<TSortingValue>();
  const [states, setStates] = useState<IState[]>([]);
  const [cities, setCities] = useState<ICity[]>([]);
  const [priceRange, setPriceRange] = useState<TRange>({ min: 0, max: 0 });
  const [undefinedPrices, setUndefinedPrices] = useState<boolean>(true);
  const [queryError, setQueryError] = useState<boolean>(false);
  const { mobile } = useSelector((state: ReducerState) => state.locale);
  const [showMenu, setShowMenu] = useState(false);

  const [years, setYears] = useState<IOptions[]>([]);
  const [brands, setBrands] = useState<IOptions[]>([]);
  const [fuels, setFuels] = useState<IOptions[]>([]);
  const [colors, setColors] = useState<IOptions[]>([]);
  const [selectedYears, setSelectedYears] = useState<IOptions[]>([]);
  const [selectedBrands, setSelectedBrands] = useState<IOptions[]>([]);
  const [selectedFuels, setSelectedFuels] = useState<IOptions[]>([]);
  const [selectedColors, setSelectedColors] = useState<IOptions[]>([]);

  const [subcategorySearch, setSubcategorySearch] = useState<string>("");
  const [subcategories, setSubcategories] = useState<IOptions[]>([]);
  const [urlSubcategory, setUrlSubcategory] = useState<TSubcategory>();
  const [selectedSubcategories, setSelectedSubcategories] = useState<
    IOptions[]
  >([]);
  const [subcategoriesError, setSubcategoriesError] = useState<TError>({
    status: false,
    message: "",
  });

  const [hideStates, setHideStates] = useState<Record<string, boolean>>({
    states: true,
    cities: true,
    categories: true,
    brands: true,
    price: true,
    years: true,
    fuels: true,
    colors: true,
  });

  const toggleHide = (key: string) => {
    setHideStates(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const getSubcategoriesFilter = () => {
    const subcategoriesFitler = urlSubcategory
      ? urlSubcategory.id
      : selectedSubcategories.map((option: IOptions) => option.id).join(",");
    return subcategoriesFitler;
  };

  const getCheckboxFilter = (selectedOptions: IOptions[]) => {
    return selectedOptions.map((option: IOptions) => option.id).join(",");
  };

  const queryTechnicalValues = useCallback(
    async (technicalAttributeIds, setFilterValues) => {
      try {
        const { data } = await api.get<TSubcategory[]>(`/attributes/values/`, {
          params: {
            technicalAttributeIds: technicalAttributeIds.join(),
            categories: PRODUCT_VEHICLE_CATEGORY_ID,
            states: getCheckboxFilter(states),
            cities: getCheckboxFilter(cities),
          },
        });

        const options = data.map(
          (item: any): IOptions => ({
            id: item.value,
            name: item.value,
            qty: item.adsQty,
          })
        );

        setFilterValues(options);
      } catch (error) {}
    },
    [
      selectedBrands,
      selectedFuels,
      selectedYears,
      selectedColors,
      cities,
      states,
      selectedSubcategories,
    ]
  );

  const querySubcategories = useCallback(async () => {
    try {
      const { data } = await api.get<TSubcategory[]>(
        "/categories/subcategories",
        {
          params: {
            search: subcategorySearch,
            categories: PRODUCT_VEHICLE_CATEGORY_ID,
            states: getCheckboxFilter(states),
            cities: getCheckboxFilter(cities),
            hideEmpty: true,
          },
        }
      );
      const options = data.map(
        (item: TSubcategory): IOptions => ({
          id: item.id,
          name: item.title,
          subvalue: item.slug,
          qty: item.adsQty,
        })
      );

      const subcategoryByUrl = data.find(item => item.slug === s);

      if (s !== "" && !subcategoryByUrl) history.push(Routes.notFound);

      subcategoryByUrl && setUrlSubcategory(subcategoryByUrl);
      setSubcategories(options);

      if (!options.length) {
        setSubcategoriesError({
          status: true,
          message: "Nenhum resultado encontrado.",
        });
      } else {
        setSubcategoriesError({
          status: false,
          message: "",
        });
      }
    } catch {
      setSubcategoriesError({
        status: true,
        message: "Erro no servidor, tente mais tarde.",
      });
    }
  }, [s, subcategorySearch, states, cities]);

  const subcategoryOptions = subcategories;

  useEffect(() => {
    querySubcategories();
  }, [querySubcategories]);

  useEffect(() => {
    queryTechnicalValues([TECHNICAL_ATTRIBUTES["MARCA"]], setBrands);
    queryTechnicalValues(
      [
        TECHNICAL_ATTRIBUTES["ANO_DE_FABRICACAO"],
        TECHNICAL_ATTRIBUTES["ANO_DO_MODELO"],
      ],
      setYears
    );
    queryTechnicalValues([TECHNICAL_ATTRIBUTES["COMBUSTIVEL"]], setFuels);
    queryTechnicalValues([TECHNICAL_ATTRIBUTES["COR"]], setColors);
  }, [queryTechnicalValues]);

  let pageTitle = "Veículos";
  if (urlSubcategory) pageTitle += ` - ${urlSubcategory.title}`;

  return (
    <Styled.Container>
      <HeaderPageTitle
        link={""}
        //sideChildren={!hideSorting && <Sorting setSorting={setSorting} />}
      >
        {pageTitle}
      </HeaderPageTitle>
      {mobile && (
        <Styled.MobileFilterContainer>
          <Styled.ButtonContainer>
            <div>Ordenar</div>
            <Styled.SelectorContainer>
              <Sorting
                newSelect={true}
                setSorting={setSorting}
                width={15}
                mobileMenu
              />
            </Styled.SelectorContainer>
          </Styled.ButtonContainer>
          <Styled.ButtonContainer
            onClick={() => {
              setShowMenu(!showMenu);
            }}
          >
            Filtrar
          </Styled.ButtonContainer>
        </Styled.MobileFilterContainer>
      )}
      {((urlSubcategory && s !== "") || !s) && (
        <List2
          useData={useVehicles}
          dataParams={{
            vehicles: true,
            categories: PRODUCT_VEHICLE_CATEGORY_ID,
            subcategories: getSubcategoriesFilter(),
            states: getCheckboxFilter(states),
            cities: getCheckboxFilter(cities),
            years: getCheckboxFilter(selectedYears),
            brands: getCheckboxFilter(selectedBrands),
            fuels: getCheckboxFilter(selectedFuels),
            colors: getCheckboxFilter(selectedColors),
            price: stringRange(priceRange, setPriceRange),
            undefinedPrices,
            published,
            perPage,
            sort: sorting && sorting.sort,
            order: sorting && sorting.order,
            userId: userId && userId,
          }}
          hideSearch={hideSearch}
          displayOn={showMenu}
          setDisplayOn={setShowMenu}
          hideFilters={hideFilters}
          hidePagination={hidePagination}
          // sorting={sorting}
          seeMoreLink={link}
          seeMoreText={"Ver mais veículos"}
          inline={inline}
          row={row}
          filters={{
            states: getCheckboxFilter(states),
            cities: getCheckboxFilter(cities),
            price: stringRange(priceRange),
            categories: [PRODUCT_VEHICLE_CATEGORY_ID],
            subcategories: getSubcategoriesFilter(),
          }}
          segment="vehicles"
          ItemLayout={(item: IAd) => (
            <>
              <AdItem
                viewCount={userId ? true : false}
                item={item}
                link={Routes.vehicle.replace(":slug", item.slug)}
              />
            </>
          )}
          queryError={queryError || !!c || (!!s && subcategoriesError.status)}
          setNoResults={setNoResults}
        >
          <>
            <Styledd.Container>
              <Styledd.SearchContainer>
                <Styledd.SearchTitleContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Estados
                  </Styledd.Title>
                  {mobile && (
                    <Styled.Expand onClick={() => toggleHide("states")}>
                      {hideStates["states"] ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )}
                </Styledd.SearchTitleContainer>
                <States
                  name="states"
                  hideSearch={hideStates["states"]}
                  setValue={setStates}
                  label={""}
                />
              </Styledd.SearchContainer>
            </Styledd.Container>

            <Styledd.Container
              style={{
                maxHeight: "228px",
                overflowY: "auto",
              }}
            >
              <Styledd.SearchContainer>
                <Styledd.SearchTitleContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Cidades
                  </Styledd.Title>
                  {mobile && (
                    <Styled.Expand onClick={() => toggleHide("cities")}>
                      {hideStates["cities"] ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )}
                </Styledd.SearchTitleContainer>
                <Cities
                  name="cities"
                  hideSearch={hideStates["cities"]}
                  setValue={setCities}
                  states={states}
                  segment="vehicles"
                  categories={PRODUCT_VEHICLE_CATEGORY_ID}
                  subcategories={getSubcategoriesFilter()}
                  hiddenLabel={true}
                />
              </Styledd.SearchContainer>
            </Styledd.Container>

            <Styledd.Container>
              <Styledd.SearchContainer>
                <Styledd.SearchTitleContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Categorias
                  </Styledd.Title>
                  {mobile && (
                    <Styled.Expand onClick={() => toggleHide("categories")}>
                      {hideStates["categories"] ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )}
                </Styledd.SearchTitleContainer>
                <Categories
                  hideSearch={hideStates["categories"]}
                  categoriesError={subcategoriesError}
                  categoryOptions={subcategoryOptions}
                  categorySearch={subcategorySearch}
                  selectedCategories={selectedSubcategories}
                  setCategorySearch={setSubcategorySearch}
                  setSelectedCategories={setSelectedSubcategories}
                  segment={{
                    name: "vehicles",
                    subvalue: "veiculos",
                  }}
                  initialCategoryOptions={[]}
                />
              </Styledd.SearchContainer>
            </Styledd.Container>

            {!!brands.length && (
              <Styledd.Container>
                <Styledd.SearchContainer>
                  <Styledd.SearchTitleContainer>
                    <Styledd.Title
                      style={{ color: "#1A1A1A" }}
                      searchHidden={false}
                      className="filters-title"
                      onClick={() => {}}
                    >
                      Marca
                    </Styledd.Title>
                    {mobile && (
                      <Styled.Expand onClick={() => toggleHide("brands")}>
                        {hideStates["brands"] ? (
                          <IoIosArrowDown size={24} />
                        ) : (
                          <IoIosArrowUp size={24} />
                        )}
                      </Styled.Expand>
                    )}
                  </Styledd.SearchTitleContainer>
                  <CheckboxSearch
                    label=""
                    hideSearch={mobile ? hideStates["brands"] : true}
                    options={brands}
                    selected={selectedBrands}
                    setSelected={setSelectedBrands}
                  />
                </Styledd.SearchContainer>
              </Styledd.Container>
            )}
            {!!years.length && (
              <Styledd.Container>
                <Styledd.SearchContainer>
                  <Styledd.SearchTitleContainer>
                    <Styledd.Title
                      style={{ color: "#1A1A1A" }}
                      searchHidden={false}
                      className="filters-title"
                      onClick={() => {}}
                    >
                      Ano
                    </Styledd.Title>
                    {mobile && (
                      <Styled.Expand onClick={() => toggleHide("years")}>
                        {hideStates["years"] ? (
                          <IoIosArrowDown size={24} />
                        ) : (
                          <IoIosArrowUp size={24} />
                        )}
                      </Styled.Expand>
                    )}
                  </Styledd.SearchTitleContainer>
                  <CheckboxSearch
                    label=""
                    hideSearch={mobile ? hideStates["years"] : true}
                    options={years}
                    selected={selectedYears}
                    setSelected={setSelectedYears}
                  />
                </Styledd.SearchContainer>
              </Styledd.Container>
            )}
            <Styledd.Container>
              <Styledd.SearchContainer>
                <Styledd.SearchTitleContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Preços
                  </Styledd.Title>
                  {mobile && (
                    <Styled.Expand onClick={() => toggleHide("price")}>
                      {hideStates["price"] ? (
                        <IoIosArrowDown size={24} />
                      ) : (
                        <IoIosArrowUp size={24} />
                      )}
                    </Styled.Expand>
                  )}
                </Styledd.SearchTitleContainer>
                <RangeField
                  name="price"
                  hideSearch={hideStates["price"]}
                  isCurrency={true}
                  change={setPriceRange}
                  values={priceRange}
                  undefinedValues={undefinedPrices}
                  setUndefinedValues={setUndefinedPrices}
                  undefinedValuesMessage={"Incluir veículos sem preço"}
                />
              </Styledd.SearchContainer>
            </Styledd.Container>
            {!!fuels.length && (
              <Styledd.Container>
                <Styledd.SearchContainer>
                  <Styledd.SearchTitleContainer>
                    <Styledd.Title
                      style={{ color: "#1A1A1A" }}
                      searchHidden={false}
                      className="filters-title"
                      onClick={() => {}}
                    >
                      Combustível
                    </Styledd.Title>
                    {mobile && (
                      <Styled.Expand onClick={() => toggleHide("fuels")}>
                        {hideStates["fuels"] ? (
                          <IoIosArrowDown size={24} />
                        ) : (
                          <IoIosArrowUp size={24} />
                        )}
                      </Styled.Expand>
                    )}
                  </Styledd.SearchTitleContainer>
                  <CheckboxSearch
                    label=""
                    options={fuels}
                    hideSearch={mobile ? hideStates["fuels"] : true}
                    selected={selectedFuels}
                    setSelected={setSelectedFuels}
                  />
                </Styledd.SearchContainer>
              </Styledd.Container>
            )}
            {!!colors.length && (
              <Styledd.Container>
                <Styledd.SearchContainer>
                  <Styledd.SearchTitleContainer>
                    <Styledd.Title
                      style={{ color: "#1A1A1A" }}
                      searchHidden={false}
                      className="filters-title"
                      onClick={() => {}}
                    >
                      Cores
                    </Styledd.Title>
                    {mobile && (
                      <Styled.Expand onClick={() => toggleHide("colors")}>
                        {hideStates["colors"] ? (
                          <IoIosArrowDown size={24} />
                        ) : (
                          <IoIosArrowUp size={24} />
                        )}
                      </Styled.Expand>
                    )}
                  </Styledd.SearchTitleContainer>
                  <CheckboxSearch
                    label=""
                    options={colors}
                    hideSearch={mobile ? hideStates["colors"] : true}
                    selected={selectedColors}
                    setSelected={setSelectedColors}
                  />
                </Styledd.SearchContainer>
              </Styledd.Container>
            )}
            {!mobile && (
              <Styledd.Container style={{ marginBottom: 88 }}>
                <Styledd.SearchContainer>
                  <Styledd.Title
                    style={{ color: "#1A1A1A" }}
                    searchHidden={false}
                    className="filters-title"
                    onClick={() => {}}
                  >
                    Ordenar por:
                  </Styledd.Title>
                  <Sorting newSelect={true} setSorting={setSorting} />
                </Styledd.SearchContainer>
              </Styledd.Container>
            )}
          </>
        </List2>
      )}
      {/* <Related
        userid={user ? user.id : ""}
        segment={segment}
        mobile={mobile}
        excludeId={0}
      /> */}
    </Styled.Container>
  );
};

export default VehicleList;
